/* Sereolys `zyara1` page — sticky buy bar + link routing.
 *
 * Every in-page link points at the product, and a sticky bar appears once the
 * reader is past the opening section.
 *
 * Lives in an asset rather than an inline <script>: inline scripts inside
 * these sections do not survive to the DOM on this store.
 *
 * Reveal is POLLED and toggled with `display` — this theme does not recompute
 * `bottom`/`transform`, and embedded/preview contexts deliver no scroll or
 * IntersectionObserver callbacks.
 */
(function () {
  'use strict';

  var PRODUCT = '/products/zyara-denture-reliner';

  /* links we must never hijack */
  var KEEP = /\/(cart|account|checkout|policies|pages\/(contact|politique|conditions|annulation|suivre))/i;

  var bar = null, shown = null, sentinel = null;

  function buildBar() {
    if (document.getElementById('zy-sticky')) return;
    bar = document.createElement('div');
    bar.id = 'zy-sticky';
    bar.innerHTML =
      '<div class="zy-sticky__in">' +
      '<div class="zy-sticky__t">' +
      '<div class="zy-sticky__t1"></div>' +
      '<div class="zy-sticky__t2"></div>' +
      '</div>' +
      '<a class="zy-sticky__btn" href="' + PRODUCT + '"></a>' +
      '</div>';
    bar.querySelector('.zy-sticky__t1').textContent = 'Sereolys — Gel de Rétention Dentaire';
    bar.querySelector('.zy-sticky__t2').textContent = 'Essai 60 nuits · Livraison offerte';
    bar.querySelector('.zy-sticky__btn').textContent = 'J’EN PROFITE';
    document.body.appendChild(bar);
  }

  function apply(v) {
    if (v === shown || !bar) return;
    shown = v;
    bar.classList.toggle('zy-on', v);
    bar.style.setProperty('display', v ? 'block' : 'none', 'important');
  }

  /* show once the opening section has scrolled past */
  function check() {
    if (!bar) return;
    if (!sentinel) {
      sentinel = document.querySelector('.zy02-adv') ||
                 document.querySelector('.zy01-adv');
    }
    if (sentinel) {
      apply(sentinel.getBoundingClientRect().bottom < 0);
      return;
    }
    apply(window.scrollY > 600);
  }

  /* every content link goes to the product */
  function routeLinks() {
    var links = document.querySelectorAll(
      '[class$="-adv"] a[href], .zy-sticky__btn');
    [].slice.call(links).forEach(function (a) {
      if (a.__zy) return;
      a.__zy = 1;
      var h = a.getAttribute('href') || '';
      if (/^(mailto:|tel:)/i.test(h)) return;
      if (KEEP.test(h)) return;
      a.setAttribute('href', PRODUCT);
    });
  }

  function init() { buildBar(); routeLinks(); check(); }

  if (document.readyState !== 'loading') init();
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  setTimeout(init, 800);
  setTimeout(init, 2200);
  window.addEventListener('scroll', check, { passive: true });
  window.addEventListener('resize', check);
  setInterval(check, 400);
})();
